var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import useStyles from './styles';
import clsx from 'clsx';
import { useTheme } from 'theming';
import { Icon } from '../Icon';
const ratio = 0.43;
const IconButton = (_a) => {
    var { icon, size = 56, color = null, variant = 'outlined', active = false, disabled = false, iconProps = {}, inlineStyles = {}, customClassName = '', innerRef = null, tooltip = null } = _a, buttonProps = __rest(_a, ["icon", "size", "color", "variant", "active", "disabled", "iconProps", "inlineStyles", "customClassName", "innerRef", "tooltip"]);
    const theme = useTheme();
    const classes = useStyles({ theme });
    const container = useRef(null);
    const [tooltipOpen, setTooltip] = useState(false);
    const aspect = Math.round(size * ratio);
    const dimensions = { height: size, width: size };
    useEffect(() => {
        const onMouseEnter = () => setTooltip(true);
        const onMouseLeave = () => setTooltip(false);
        const self = innerRef ? innerRef.current : container.current;
        if (Boolean(tooltip)) {
            self.addEventListener('mouseenter', onMouseEnter);
            self.addEventListener('mouseleave', onMouseLeave);
        }
        return () => {
            self.removeEventListener('mouseenter', onMouseEnter);
            self.removeEventListener('mouseleave', onMouseLeave);
        };
    }, [tooltip, innerRef]);
    const containerStyle = clsx({
        [customClassName]: Boolean(customClassName),
        [classes.container]: true,
        [classes[variant]]: Boolean(variant),
        [classes[color]]: Boolean(color),
        [classes.active]: active,
        [classes.contained_disabled]: variant === 'contained' && disabled,
        [classes.outlined_disabled]: variant === 'outlined' && disabled,
        [classes[`${color}_${variant}`]]: variant === 'contained',
        [classes[`${variant}_default`]]: !Boolean(color),
    });
    const self = innerRef ? innerRef : container;
    return (React.createElement(React.Fragment, null,
        React.createElement("button", Object.assign({ ref: self, className: containerStyle, style: Object.assign(Object.assign({}, dimensions), inlineStyles), disabled: disabled }, buttonProps),
            React.createElement(Icon, Object.assign({ name: icon, height: aspect, width: aspect, color: color, disabled: disabled, variant: variant === 'outlined' ? 'regular' : 'contrast' }, iconProps)))));
};
export { IconButton };
//# sourceMappingURL=IconButton.js.map